import React from 'react';
import PropTypes from 'prop-types';
import PageHeader from '@adsk/alloy-react-page-header';
import { useLocale } from '@adsk/alloy-react-locale';
import {
  OP_STATUSES,
  PREDEFINED_PROJECT_ADMIN_SETTINGS_TABS_IDS,
} from '@adsk/acs-admin-ui-components-helpers';
import PageHeaderTabs from './PageHeaderTabs';

/** Project Settings shared Admin component with included Project Profile pre-loaded content */
const SettingsTabs = ({
  activeTab,
  className,
  isEmsAccount,
  onProfileSave,
  onTabChange,
  showAdminSettings,
  tabs,
}) => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));

  return (
    <>
      <PageHeader
        className={className}
        style={{ borderBottom: 'none' }}
        title={T.translate('TITLE')}
      />
      <PageHeaderTabs
        activeTab={activeTab}
        isEmsAccount={isEmsAccount}
        tabs={tabs}
        onProfileSave={onProfileSave}
        onTabChange={onTabChange}
        showAdminSettings={showAdminSettings}
      />
    </>
  );
};

SettingsTabs.propTypes = {
  /** The identifier (passed on the tabs prop) for the initially selected tab  */
  activeTab: PropTypes.string,
  /** Customizable classes to be added to the PageHeader */
  className: PropTypes.string,
  /** Optional flag to show ems account type specific UI */
  isEmsAccount: PropTypes.bool,
  /** Callback executed upon saving the Project Profile information */
  onProfileSave: PropTypes.func,
  /** Callback executed upon tab change, newly selected tab is passed as a param */
  onTabChange: PropTypes.func,
  /** Should admin settings controls be shown? */
  showAdminSettings: PropTypes.bool,
  /** Array of tabs objects to create in addition to the pre existing "Profile" tab */
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.node,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      // eslint-disable-next-line react/forbid-prop-types
      labelProps: PropTypes.object,
      tab: PropTypes.string.isRequired,
      url: PropTypes.string,
    })
  ),
};

SettingsTabs.defaultProps = {
  activeTab: PREDEFINED_PROJECT_ADMIN_SETTINGS_TABS_IDS.PROJECT,
  className: undefined,
  isEmsAccount: false,
  onProfileSave: () => {},
  onTabChange: () => {},
  showAdminSettings: false,
  tabs: [],
};

SettingsTabs.editProfileOpStatuses = OP_STATUSES;
SettingsTabs.PREDEFINED_PROJECT_ADMIN_SETTINGS_TABS_IDS =
  PREDEFINED_PROJECT_ADMIN_SETTINGS_TABS_IDS;

export default SettingsTabs;
